// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../plugins/owl.carousel.min';

export default class AdvancedCarousel extends WebComponent {
  constructor(props) {
    super(props);

    this.data = this.props.carouselData || {};
  }

  didMount() {
    this.element.classList.add('owl-carousel');
    $(this.element).owlCarousel({
      lazyLoad: true,
      ...this.data,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/AdvancedCarousel.js